import { render, staticRenderFns } from "./PayItems.vue?vue&type=template&id=2925ec4a"
import script from "./PayItems.vue?vue&type=script&lang=js"
export * from "./PayItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports